import React from "react";
import CustomDrawer from "../../common/CustomDrawer";
import { IPACReading } from "../../../vm";
import { ToastContext } from "../../common/ToastProvider";
import {
  Stack,
  IStackTokens,
  DefaultButton,
  PrimaryButton,
  Toggle,
} from "office-ui-fabric-react";
import { Formik } from "formik";
import { updatePacReading } from "../../../services/infrastructure/PacService";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";
import { getAlertDetails } from "../../../services/ThresholdService";
import * as yup from "yup";
import { CustomTextField } from "../../common/Library";
import { CategoryHeader } from "../Misc";
import { childrenGap } from "../../common/Constants";

const pacReadingSchema = yup.object().shape({
  supplyTemp: yup.number().required("required"),
  rh: yup.number().required("required"),
  roomTemp: yup.number().required("required"),
  recordedBy: yup.string().required("required"),
  remarks: yup.string().optional(),
  anyAlarm: yup.string().optional(),
  // isOn: yup.boolean().optional()
});

export interface ManagePacDialogProps {
  data?: IPACReading;
  handleLoading: any;
  handleDialogClose: any;
  threshold: any;
}

const ManagePacDialog: React.FC<ManagePacDialogProps> = ({
  data,
  handleDialogClose,
  handleLoading,
  threshold,
}) => {
  //state
  const [state, setState] = React.useState({
    pacReading: {
      ...data,
    },
    isLoading: false,
  } as {
    pacReading: IPACReading;
    isLoading: boolean;
  });

  //hooks
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);

  const isMumbaiAndheri = ["5db6dd581622512263977721"].includes(
    data?.datacenterId as string
  );

  const wrapStackTokens: IStackTokens = { childrenGap: 8 };

  const closeUpdateDialoge = (data?: IPACReading) => {
    handleDialogClose(data);
  };

  const onBlurFunc = (value: any, path: string) => {
    // console.log("onBlurFunc");
    const { showAlert, msg } = getAlertDetails(path, threshold, value);
    // console.log("[showAlert]", showAlert, msg);
    if (showAlert === true) {
      showConfirmDialog("Alert", msg as string, () => { }, "Ok", true);
    }
  };

  return (
    <React.Fragment>
      <CustomDrawer
        title={"Update PAC Reading"}
        handelOpen={true}
        onClose={() => closeUpdateDialoge()}
      >
        <Stack>
          <Formik
            initialValues={state.pacReading}
            // validationSchema={pacReadingSchema}
            onSubmit={async (values: IPACReading, { setSubmitting }) => {
              let data = { ...values };
              let result;
              handleLoading();
              result = await updatePacReading(data);
              handleLoading();
              if (result.success) {
                closeUpdateDialoge(result.data);
                showToast("PAC Reading updated successfully", "success");
              } else {
                showToast("Error while updating PAC Reading", "error");
              }
              setSubmitting(false);
            }}
          >
            {({ handleSubmit, setFieldValue, values }) => (
              <form onSubmit={handleSubmit}>
                <Stack wrap tokens={wrapStackTokens}>
                  <Stack.Item className="custom-toggle">
                    <Toggle
                      checked={values.isOn}
                      label="System"
                      onText="On"
                      offText="Off"
                      onChange={(e, v) => {
                        setFieldValue("isOn", v);
                      }}
                    />
                  </Stack.Item>
                  <Stack.Item>
                    <Stack horizontal wrap tokens={childrenGap}>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"supplyTemp"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={
                            !isMumbaiAndheri ? "Supply Temperature" : "RAT"
                          }
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"roomTemp"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Room Temperature"}
                        />
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>

                  <Stack.Item>
                    <CustomTextField
                      name={"rh"}
                      onBlurFunc={onBlurFunc}
                      type="number"
                      label={"RH %"}
                    />
                  </Stack.Item>

                  <Stack.Item>
                    <Stack horizontal wrap tokens={childrenGap}>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"tempSetPoint"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"Temp Set Point"}
                        />
                      </Stack.Item>
                      <Stack.Item grow={1}>
                        <CustomTextField
                          name={"rhSetPoint"}
                          onBlurFunc={onBlurFunc}
                          type="number"
                          label={"RH Set Point"}
                        />
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>

                  <Stack.Item>
                    <CategoryHeader title="General" />
                    <Stack tokens={wrapStackTokens} className="pt-24">
                      <Stack.Item>
                        <CustomTextField
                          name={"anyAlarm"}
                          label={"Alarm (If Any)"}
                        />
                      </Stack.Item>
                      <Stack.Item>
                        <CustomTextField
                          name={"remarks"}
                          label={"Remarks (If Any)"}
                          multiline
                          autoAdjustHeight
                        />
                      </Stack.Item>
                      <Stack.Item>
                        <Stack
                          horizontal
                          wrap
                          tokens={childrenGap}
                          verticalAlign="end"
                        >
                          <Stack.Item grow={1} className="pt-24">
                            <CustomTextField
                              name={"recordedBy"}
                              label={"Shift Tech Sign"}
                              disabled={true}
                            />
                          </Stack.Item>
                        </Stack>
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>
                  <br />
                  <Stack.Item>
                    <Stack
                      horizontal
                      wrap
                      tokens={wrapStackTokens}
                      horizontalAlign="end"
                    >
                      <DefaultButton
                        text="Cancel"
                        onClick={() => closeUpdateDialoge()}
                        className="borderless-btn"
                      />
                      <PrimaryButton type="submit" text="Update" />
                    </Stack>
                  </Stack.Item>
                </Stack>
              </form>
            )}
          </Formik>
        </Stack>
      </CustomDrawer>
    </React.Fragment>
  );
};

export default ManagePacDialog;
